// Shared strings reused across many pages/components (buttons, statuses, generic labels).
const en = {
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  create: 'Create',
  update: 'Update',
  remove: 'Remove',
  search: 'Search',
  searchPlaceholder: 'Search... (Ctrl+K)',
  loading: 'Loading...',
  saving: 'Saving...',
  deleting: 'Deleting...',
  submit: 'Submit',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',
  actions: 'Actions',
  status: 'Status',
  name: 'Name',
  description: 'Description',
  quantity: 'Quantity',
  price: 'Price',
  total: 'Total',
  date: 'Date',
  notes: 'Notes',
  type: 'Type',
  category: 'Category',
  view: 'View',
  viewDetails: 'View Details',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  filter: 'Filter',
  filters: 'Filters',
  clearFilters: 'Clear Filters',
  all: 'All',
  none: 'None',
  noResults: 'No results found',
  noData: 'No data available',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  required: 'Required',
  optional: 'Optional',
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  completed: 'Completed',
  cancelled: 'Cancelled',
  approve: 'Approve',
  reject: 'Reject',
  export: 'Export',
  import: 'Import',
  print: 'Print',
  download: 'Download',
  upload: 'Upload',
  refresh: 'Refresh',
  select: 'Select',
  selectOption: 'Select an option',
  areYouSure: 'Are you sure?',
  actionCannotBeUndone: 'This action cannot be undone.',
  somethingWentWrong: 'Something went wrong. Please try again.',
  requiredField: 'This field is required',
  min: 'Min',
  max: 'Max',
  from: 'From',
  to: 'To',
  id: 'ID',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  ctrlK: 'Ctrl+K',
};

const de = {
  save: 'Speichern',
  cancel: 'Abbrechen',
  close: 'Schließen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  create: 'Erstellen',
  update: 'Aktualisieren',
  remove: 'Entfernen',
  search: 'Suchen',
  searchPlaceholder: 'Suchen... (Strg+K)',
  loading: 'Wird geladen...',
  saving: 'Wird gespeichert...',
  deleting: 'Wird gelöscht...',
  submit: 'Absenden',
  confirm: 'Bestätigen',
  yes: 'Ja',
  no: 'Nein',
  actions: 'Aktionen',
  status: 'Status',
  name: 'Name',
  description: 'Beschreibung',
  quantity: 'Menge',
  price: 'Preis',
  total: 'Gesamt',
  date: 'Datum',
  notes: 'Notizen',
  type: 'Typ',
  category: 'Kategorie',
  view: 'Ansehen',
  viewDetails: 'Details anzeigen',
  back: 'Zurück',
  next: 'Weiter',
  previous: 'Zurück',
  filter: 'Filter',
  filters: 'Filter',
  clearFilters: 'Filter zurücksetzen',
  all: 'Alle',
  none: 'Keine',
  noResults: 'Keine Ergebnisse gefunden',
  noData: 'Keine Daten verfügbar',
  error: 'Fehler',
  success: 'Erfolg',
  warning: 'Warnung',
  required: 'Erforderlich',
  optional: 'Optional',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  pending: 'Ausstehend',
  completed: 'Abgeschlossen',
  cancelled: 'Storniert',
  approve: 'Genehmigen',
  reject: 'Ablehnen',
  export: 'Exportieren',
  import: 'Importieren',
  print: 'Drucken',
  download: 'Herunterladen',
  upload: 'Hochladen',
  refresh: 'Aktualisieren',
  select: 'Auswählen',
  selectOption: 'Option auswählen',
  areYouSure: 'Sind Sie sicher?',
  actionCannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  somethingWentWrong: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  requiredField: 'Dieses Feld ist erforderlich',
  min: 'Min',
  max: 'Max',
  from: 'Von',
  to: 'Bis',
  id: 'ID',
  createdAt: 'Erstellt am',
  updatedAt: 'Aktualisiert am',
  createdBy: 'Erstellt von',
  updatedBy: 'Aktualisiert von',
  ctrlK: 'Strg+K',
};

const common = { en, de };
export default common;
